import { PaletteColor } from '@mui/material';

export const boxShadowGameLettersReveal = (paletteColor: PaletteColor) =>
  `${paletteColor.main} 0px 0px 5px -1px, ${paletteColor.main} 0px 0px 5px 0px, ${paletteColor.main} 0px 0px 5px 0px`;
